import * as React from 'react';
import { Field } from 'formik';
import {
  Select,
  Input,
  Upload,
  Modal,
  DatePicker,
  Tooltip,
  Button,
  Checkbox,
} from 'antd';
import { InfoCircleTwoTone, UploadOutlined, DeleteOutlined, ReloadOutlined } from '@ant-design/icons';

const { TextArea }: any = Input;
const { Option } = Select;
interface Props {
  name: string;
  type: string;
  label?: string;
  placeholder?: string;
  icon?: string;
  iconLocation?: string;
  step?: string;
  errors: any;
  touched: any;
  children?: any;
  onClick?: any;
  onInput?: any;
  value?: any;
  disabled?: any;
  defaultValue?: any;
  onChange?: any;
  defaultClassName?: string;
  search?: string;
  extra?: any;
  multiple?: any;
  rows?: any;
  lebelInstructions?: any;
  isRequired?: any;
  index?: any;
  apis?: any;
  dispatch?: any;
  addonBefore?: any;
  more?: any;
  importData?: any;
  callRefreshAPI?: any;
  onChangeFieldValue?: any;
}
import { LinkOutlined } from '@ant-design/icons';
import './styles.scss';
import SunEditorView from './SunEditor';
import { getDataBy } from '../../actions/apiCall';
import DynamicSelect from '../Select/DynamicSelect';

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}

interface State {
  previewImage: any;
  previewVisible: any;
  previewTitle: any;
  fileList: any;
  numberValue: any;
  childrens?: any;
}

class InputView extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      previewImage: '',
      previewVisible: '',
      previewTitle: '',
      fileList: [],
      numberValue: null,
      childrens: null
    };
  }

  getKey(errors, keyName) {
    return `${errors[keyName]}`;
  }

  async onSearch(value, keyName) {
    if (value) {
      if (this.props.extra && this.props.extra.type == 'form' && keyName) {
        const name = keyName.split('.');
        const key = name[1].toString();
        const { api, idKey, nameKey, render, isJoin } = this.props.apis.filter(ele => ele.name == key)[0];
        const names = Array.isArray(nameKey) ? nameKey : [nameKey];
        const resData = await this.props.dispatch(getDataBy(api + `?search=${value}&keys=${names.join(',')}`));
        const optionData = resData.data.map((ele) => {
          const nameList = render ? render(ele) : names.map(names => ele[names]).join(isJoin ? isJoin : ' ');
          return { name: nameList, value: ele[idKey] };
        });
        this.setState({ childrens: optionData });
      } else if (this.props.extra && this.props.extra.isCombo) {

        const { key } = this.props.extra;
        const { api, idKey, nameKey } = this.props.apis.filter(ele => ele.name == key)[0];
        const resData = await this.props.dispatch(getDataBy(api + `?search=${value}&keys=${Array.isArray(nameKey) ? nameKey.join(',') : nameKey}`));
        console.log('-------------------', this.props, api, idKey, nameKey);
        const optionData = resData.data.map((ele) => {
          const nameList = typeof nameKey === 'string' ? [nameKey].map(names => ele[names]).join(' ') : nameKey.map(names => ele[names]).join(' ');
          return { name: nameList, value: ele[idKey] };
        });

        this.setState({ childrens: optionData });
      }
    } else {
      this.setState({ childrens: null });
    }
  }

  render() {
    let showLabel = this.props.label !== undefined;
    let className = 'input normal';
    const { previewVisible, fileList, previewTitle } = this.state;

    const uploadButton = (
      <div>
        <Button style={{ marginTop: 0, width: '100%' }}><LinkOutlined /> Upload</Button>
      </div>
    );

    if (
      this.props.errors[this.props.name] &&
      this.props.touched[this.props.name]
    ) {
      className += ' is-danger';
    }

    let field = null;
    if (this.props.search !== undefined) {
      field = (
        <Field
          className={className}
          type={this.props.type}
          name={this.props.name}
          onChange={(e) => this.props.onChange(e)}
          placeholder={this.props.placeholder}
          step={this.props.step}
          onClick={this.props.onClick}
          onInput={this.props.onInput}
          value={this.props.value}
          autoComplete="none"
        />
      );
    } else if (this.props.value !== undefined) {
      field = (
        <Field
          className={className}
          type={this.props.type}
          name={this.props.name}
          placeholder={this.props.placeholder}
          step={this.props.step}
          onClick={this.props.onClick}
          onInput={this.props.onInput}
          value={this.props.value}
        />
      );
    } else if (this.props.disabled !== undefined) {
      field = (
        <Field
          className={className}
          type={this.props.type}
          name={this.props.name}
          placeholder={this.props.placeholder}
          step={this.props.step}
          onClick={this.props.onClick}
          disabled
        />
      );
    } else {
      field = (
        <Field
          className={className}
          name={this.props.name}
          defaultValue={this.props.defaultValue}
        >
          {({ form }) => (
            <label className="file-label">
              <Input
                defaultValue={this.props.defaultValue}
                name={this.props.name.toString()}
                addonBefore={this.props.addonBefore}
                placeholder={this.props.placeholder}
                autoComplete="none"
                onChange={(event) => {
                  form.setFieldValue(
                    this.props.name,
                    event.currentTarget.value
                  );
                }}
                {...this.props.more}
              />
            </label>
          )}
        </Field>
      );
    }

    switch (this.props.type) {
      case 'DynamicSelect':
        field = (
          <Field
            name={this.props.name}
            defaultValue={this.props.defaultValue}
            placeholder={this.props.placeholder || 'Select'}
          >
            {({ form }) => (
              <label className="file-label">
                <DynamicSelect
                  name={this.props.name}
                  multiple={this.props.multiple}
                  keyName={this.props.name}
                  fieldKey={this.props.name}
                  more={this.props.more} />
              </label>
            )}
          </Field>
        );
        break;
      case 'select':
        field = (
          <Field
            name={this.props.name}
            defaultValue={this.props.defaultValue}
            placeholder={this.props.placeholder || 'Select'}
          >
            {({ form }) => (
              <label className="file-label">
                {!this.props.multiple && (
                  <Select
                    showSearch
                    disabled={this.props.disabled}
                    defaultValue={this.props.defaultValue}
                    placeholder={this.props.placeholder || 'Select'}
                    filterOption={!this.state.childrens}
                    maxTagCount={1}
                    maxTagTextLength={10}
                    onSearch={(value) => this.onSearch(value, this.props.name)}
                    onChange={(event) => {
                      if (this.props.onChangeFieldValue) {
                        this.props.onChangeFieldValue(event);
                      }
                      form.setFieldValue(this.props.name, event);
                      this.props.onChange(event);
                    }}
                  >
                    {this.state.childrens ? this.state.childrens.map(ele =>
                      <Option key={ele.name} value={ele.value}>{ele.name}</Option>
                    )
                      : (this.props.children !== undefined
                        ? this.props.children
                        : null)}
                  </Select>
                )}
                {this.props.multiple && (
                  <Select
                    mode={'multiple'}
                    showSearch
                    maxTagCount={1}
                    maxTagTextLength={10}
                    filterOption={!this.state.childrens}
                    onSearch={(value) => this.onSearch(value, this.props.name)}
                    disabled={this.props.disabled}
                    defaultValue={
                      !this.props.defaultValue ? [] : this.props.defaultValue
                    }
                    placeholder={this.props.placeholder || 'Select'}
                    onChange={(event) => {
                      if (this.props.onChangeFieldValue) {
                        this.props.onChangeFieldValue(event);
                      }
                      form.setFieldValue(this.props.name, event);
                      this.props.onChange(event);
                    }}
                  >
                    {this.props.children !== undefined
                      ? this.props.children
                      : null}
                  </Select>
                )}
              </label>
            )}
          </Field>
        );
        break;
      case 'checkbox':
        showLabel = false;
        field = (
          <label className="checkbox">
            <Field name={this.props.name}>
              {({ field, form }) => {
                return (
                  <Checkbox
                    disabled={this.props.disabled}
                    checked={field.value}
                    name={this.props.name}
                    onChange={(e) => {
                      console.log(
                        'form.setFieldValue(this.props.name, !field.value)',
                        e
                      );
                      form.setFieldValue(this.props.name, e.target.checked);
                    }}
                  >
                    {this.props.label}
                  </Checkbox>
                );
              }}
            </Field>
          </label>
        );
        break;

      case 'followCheckbox':
        showLabel = false;
        field = (
          <label className="checkbox">
            <Field name={this.props.name}>
              {({ form }) => (
                <input
                  type="checkbox"
                  checked={this.props.defaultValue}
                  onChange={() => {
                    form.setFieldValue(this.props.name, this.props.value);
                  }}
                />
              )}
            </Field>
            &nbsp;
            {this.props.label}
          </label>
        );
        break;
      case 'number':
        field = (
          <Field name={this.props.name}>
            {({ form }) => (
              <label className="file-label">
                <Input
                  type={'number'}
                  disabled={this.props.disabled}
                  defaultValue={this.props.defaultValue}
                  name={this.props.name}
                  addonBefore={this.props.addonBefore}
                  placeholder={this.props.placeholder}
                  autoComplete="none"
                  onChange={(event) => {
                    this.setState({ numberValue: event.currentTarget.value });
                    form.setFieldValue(
                      this.props.name,
                      event.currentTarget.value
                    );
                  }}
                  {...this.props.more}
                />
              </label>
            )}
          </Field>
        );
        break;
      case 'password':
        field = (
          <Field name={this.props.name}>
            {({ form }) => (
              <label className="file-label">
                <Input.Password
                  type={'password'}
                  disabled={this.props.disabled}
                  defaultValue={this.props.defaultValue}
                  name={this.props.name}
                  placeholder={this.props.placeholder}
                  autoComplete="none"
                  onChange={(event) => {
                    form.setFieldValue(
                      this.props.name,
                      event.currentTarget.value
                    );
                  }}
                />
              </label>
            )}
          </Field>
        );
        break;

      case 'textarea':
        field = (
          <Field name={this.props.name}>
            {({ form }) => (
              <label className="file-label">
                <TextArea
                  disabled={this.props.disabled}
                  placeholder={this.props.placeholder}
                  defaultValue={this.props.defaultValue}
                  rows={this.props.rows || 4}
                  onChange={(event) => {
                    form.setFieldValue(
                      this.props.name,
                      event.currentTarget.value
                    );
                  }}
                ></TextArea>
              </label>
            )}
          </Field>
        );
        break;

      case 'textQuill':
        field = (
          <Field name={this.props.name}>
            {({ form }) => (
              <>
                {/* <label className={"file-label editor-normal " + className} /> */}
                <SunEditorView
                  disable={this.props.disabled}
                  small={this.props.more ? this.props.more.small : false}
                  defaultValue={this.props.defaultValue}
                  onChange={(e) => this.handleTextChange(e, form)}
                />
              </>
            )}
          </Field>
        );
        break;

      case 'file':
        field = (
          <Field name={this.props.name}>
            {({ field, form }) => {
              const fileExt = this.getFileType(field.value);
              let fileURL = process.env.FILE_URL + field.value;
              if (fileExt && fileExt.includes('pdf')) {
                fileURL = require('../../assets/images/Icons/pdf.png');
              } else if (fileExt && fileExt.includes('doc')) {
                fileURL = require('../../assets/images/Icons/doc.png');
              } else if (fileExt && fileExt.includes('xls')) {
                fileURL = require('../../assets/images/Icons/excel.png');
              }

              if (field.value) {
                const fileName = field.value.split('/');
                return (
                  <div>
                    <Modal
                      style={{ maxWidth: '80%', minWidth: '70%', height: '100%' }}
                      open={previewVisible}
                      title={previewTitle}
                      footer={null}
                      onCancel={this.handleCancel}
                    >
                      {fileExt && fileExt.includes('pdf') ? <iframe className="iframeWindow" src={`${process.env.FILE_URL}${field.value}`} /> : <img
                        alt="example"
                        style={{ width: '100%' }}
                        src={`${process.env.FILE_URL}${field.value}`}
                      />}
                    </Modal>
                    <div className="button-upload-prev">
                      <div onClick={this.handlePreviewView} style={{ cursor: 'pointer' }}>
                        <img
                          alt="examples"
                          className="fit-img-css"
                          style={{ width: '100%' }}
                          src={`${fileURL}`}
                        />
                        <div className="title-file" title={fileName[fileName.length - 1]}>{fileName[fileName.length - 1]}</div>
                      </div>
                      {!this.props.disabled && <DeleteOutlined color="red" onClick={() => { this.handleChange({ fileList: [] }, form); }} />}
                    </div>
                  </div>
                );
              } else {
                return (
                  <div>
                    <Upload
                      action={`${process.env.API_URL}/upload/add`}
                      listType="text"
                      onPreview={this.handlePreview}
                      onChange={(e) => this.handleChange(e, form)}
                      disabled={this.props.disabled}
                    >
                      {fileList.length >= 1 ? null : uploadButton}
                    </Upload>
                  </div>
                );
              }
            }}
          </Field>
        );
        break;
      case 'upload':
        field = (
          <Field name={this.props.name}>
            {({ field, form }) => {
              const files: any = [
                ...[field && field.value ? `${field.value}` : false],
                ...[fileList && fileList.length ? fileList : false],
              ]
                .filter(Boolean)
                .map((ele, index) => ({
                  uid: '-' + index,
                  name: ele,
                  status: 'done',
                  url: process.env.FILE_URL + ele,
                  thumbUrl: process.env.FILE_URL + ele,
                }));
              console.log('filesfiles', files);
              return (
                <div>
                  <Upload
                    action={`${process.env.API_URL}/upload/add`}
                    listType="picture"
                    defaultFileList={files}
                    onChange={(e) => this.handleChange(e, form)}
                    className="upload-list-inline"
                  >
                    {files.length == 0 && (
                      <Button icon={<UploadOutlined />}>Upload</Button>
                    )}
                  </Upload>
                </div>
              );
            }}
          </Field>
        );
        break;
      case 'date': {
        field = (
          <Field className={className} name={this.props.name}>
            {({ form }) => (
              <label className="file-label">
                <DatePicker
                  style={{ width: '100%' }}
                  defaultValue={(this.props.defaultValue && this.props.defaultValue.isValid()) ? this.props.defaultValue : null}
                  placeholder={this.props.placeholder}
                  disabled={this.props.disabled}
                  disabledDate={(e) => this.disabledDate(e, this.props)}
                  autoComplete="none"
                  onClick={this.props.onClick}
                  onChange={(event) => {
                    if (this.props.onChangeFieldValue) {
                      this.props.onChangeFieldValue(event);
                    }
                    form.setFieldValue(this.props.name, event);
                  }}
                  {...this.props.more}
                />
              </label>
            )}
          </Field>
        );
      }
    }

    const iconLocation = this.props.iconLocation
      ? this.props.iconLocation
      : 'right';

    return (
      <>
        {showLabel && (
          <label className="label">
            {this.props.label}
            {this.props.isRequired && <span style={{ color: 'red' }}> * </span>}
            {this.props.lebelInstructions && (
              <Tooltip title={this.props.lebelInstructions}>
                <InfoCircleTwoTone />
              </Tooltip>
            )}
            {this.props.importData && (
              <Tooltip title={this.props.importData.info}>
                <ReloadOutlined onClick={() => this.props.callRefreshAPI(this.props.importData)} />
              </Tooltip>
            )}
          </label>
        )}
        <div
          className={`control${this.props.icon !== undefined ? ` has-icons-${iconLocation}` : ''
            }`}
        >
          {field}
        </div>
        <p className="help is-danger">{this.getErroreMessage()}</p>
        {this.props.extra?.note && <small>{this.props.extra?.note}</small>}
      </>
    );
  }

  getErroreMessage = () => {
    // const regex = /\d+/g;
    if (
      this.props.errors[this.props.name] &&
      this.props.touched[this.props.name]
    ) {
      return this.props.errors[this.props.name];
    } else if (
      this.props.name &&
      this.props.name.includes('[') &&
      this.props.errors
    ) {
      return undefined;
    }
  };

  handleCancel = () => {
    this.setState({ previewVisible: false });
  };

  handlePreviewView = () => {
    this.setState({
      previewImage: true,
      previewVisible: true,
      previewTitle: 'View',
    });
  };

  handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }

    this.setState({
      previewImage: file.url || file.preview,
      previewVisible: true,
      previewTitle:
        file.name || file.url.substring(file.url.lastIndexOf('/') + 1),
    });
  };

  disabledDate(_current, _props) {
    const result = false;
    return result;
  }

  handleChange = ({ fileList }, form) => {
    if (fileList && fileList.length > 0 && fileList[0].response) {
      this.setState({ fileList: fileList[0].response.files });
      form.setFieldValue(this.props.name, fileList[0].response.files[0]);
    } else {
      this.setState({ fileList: [] });
      form.setFieldValue(this.props.name, '');
    }
  };

  handleTextChange = (e, form) => {
    console.log('eee', e);
    form.setFieldValue(this.props.name, e);
  };

  getFileType = (value) => {
    return /[^.]+$/.exec(value);
  };

}

export default InputView;
